import { useState, useEffect } from 'react'
import Button from '../Button/Button'
import Input from '../form/input'
import AuthImage from '../AuthImage/AuthImage'
import './AddPhotoModal.css'

function AddPhotoModal({ modalStatus, changeStatus, onSave, photo, title, imageBasePath }) {
    const isEditing = !!photo

    const [file, setFile] = useState(null)
    const [description, setDescription] = useState('')
    const [saving, setSaving] = useState(false)
    const [previewUrl, setPreviewUrl] = useState(null)

    useEffect(() => {
        if (!modalStatus) return
        setFile(null)
        setDescription(photo?.description || '')
        setSaving(false)
        const onKey = (e) => { if (e.key === 'Escape') changeStatus(false) }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [modalStatus, photo, changeStatus])

    useEffect(() => {
        if (file) {
            const url = URL.createObjectURL(file)
            setPreviewUrl(url)
            return () => URL.revokeObjectURL(url)
        }
        setPreviewUrl(null)
    }, [file])

    if (!modalStatus) return null

    async function handleSave() {
        setSaving(true)
        await onSave(file, description)
        setSaving(false)
    }

    const resolvedTitle = title || (isEditing ? 'Editar foto' : 'Adicionar foto')

    return (
        <div className="apm-overlay" onClick={() => changeStatus(false)}>
            <div className="apm-box" onClick={(e) => e.stopPropagation()}>

                <button type="button" className="apm-close shd-modal-close" onClick={() => changeStatus(false)}>X</button>

                <div className="apm-header">
                    <div className="apm-header-top">
                        <div>
                            <p className="apm-title">{resolvedTitle}</p>
                            <span className="apm-accent" />
                        </div>
                    </div>
                    <div className="apm-header-actions">
                        <Button variant="save" type="button" onClick={handleSave} disabled={saving || (!isEditing && !file)}>
                            {saving ? 'Enviando...' : (isEditing ? 'Salvar' : 'Adicionar')}
                        </Button>
                        <Button variant="cancel" type="button" onClick={() => changeStatus(false)}>Cancelar</Button>
                    </div>
                </div>

                <div className="apm-body">
                    <div className="form-group">
                        <label className="input-label">Foto:</label>
                        <input
                            type="file"
                            className="input"
                            accept="image/png,image/jpeg"
                            onChange={(e) => setFile(e.target.files[0] || null)}
                        />
                    </div>

                    {previewUrl ? (
                        <div className="apm-preview">
                            <img className="apm-preview-img" src={previewUrl} alt="Pré-visualização" />
                        </div>
                    ) : (isEditing && photo?.filename) && (
                        <div className="apm-preview">
                            <AuthImage
                                className="apm-preview-img"
                                src={`${imageBasePath || '/images/generator'}/${photo.filename}`}
                                alt="Pré-visualização"
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <Input
                            text="Descrição"
                            type="text"
                            name="description"
                            placeholder="Descreva o que é a foto"
                            value={description}
                            handleOnChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AddPhotoModal
